import { createArraySelector } from 'reselect-map'

import parentsRGBColor from 'helpers/parentColorToRGB'

const myLibraryParentsSelector = state => state.myLibrary.parents
const folderColors = state => state.folders.colors

const parentsSelector = createArraySelector(
	[ myLibraryParentsSelector, folderColors ],
	(parent, colors) => ({
		...parent,
		color: parentsRGBColor(parent, colors),
	})
)

export default parentsSelector
